import BasePostIdApi from "./BasePostIdApi";

export default class PostLikeApi extends BasePostIdApi {
	protected override getBaseUrl(params: Record<string, string>) {
		return `${super.getBaseUrl(params)}/likes`;
	}

	/**
	 * @description Count all likes on a post
	 */
	public async count(projectId: string, postId: string): Promise<{ count: number }> {
		return this.getRequest<{ count: number }>(this.getBaseUrl({ projectId, postId }));
	}

	/**
	 * @description Check if the user liked a post
	 */
	public async isLiked(projectId: string, postId: string): Promise<{ isLiked: boolean }> {
		return this.getRequest<{ isLiked: boolean }>(`${this.getBaseUrl({ projectId, postId })}/me`);
	}

	/**
	 * @description Like a post
	 */
	public async like(projectId: string, postId: string): Promise<void> {
		return this.postRequest(`${this.getBaseUrl({ projectId, postId })}/me`);
	}

	/**
	 * @description Unlike a post
	 */
	public async unlike(projectId: string, postId: string): Promise<void> {
		return this.deleteRequest(`${this.getBaseUrl({ projectId, postId })}/me`);
	}
}
